import { AnimationFeature } from "./animation/index.js";
import { ExitAnimationFeature } from "./animation/exit.js";
const animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};
export {
  animations
};
//# sourceMappingURL=animations.js.map
